<div class="item-main-page__page">
    <router-outlet></router-outlet>
</div>